<style src="./Home.scss" lang="scss" scoped></style>
<script src="./Home.js"></script>

<template>
	<div class="home-contain">
		<WelcomeComponent />
	</div>
</template>